/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import UnitClass from "../../components/UnitClass";

const AdminUnitClass = (props) => {
    return (
        <UnitClass {...props} moduleType={'Admin'} />
    )
}

export default AdminUnitClass